<form [formGroup]="form" (ngSubmit)="onSubmit(form)">
    <div class="col">
        <h2>
            @if(messageMaintenance != undefined){
            Modifier le message
            } @else {
            Publier un message
            }
        </h2>
        <tui-textfield>
            <label tuiLabel>Message *</label>
            <input formControlName="message" placeholder="Votre Message" tuiTextfield />
            <tui-error formControlName="message" [error]="[] | tuiFieldError | async" />
        </tui-textfield>
        <button tuiButton>Publier</button>
    </div>
</form>